// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Link_wrapper__2oZ8p","linkLight":"Link_linkLight__v7rAU"};